/* eslint complexity: [1, 10] */
/* eslint max-depth: [1, 14] */
/* global u */


import ScrollSpy from './scrollspy';
import pushState from '../../00-base/global/utils/push-state'

const LINK_CURRENT_CLASS = 'active';

/**
 * Get current scroll position;
 * @return {number} Current scroll position;
 */
function getScrollPos() {
  return window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
}


/**
 * Initialization of inpage nav functionality.
 */
export default function(documentScroller) {
  const nav = document.getElementById("nav-inpage");
  if (nav) {
    const inner_list = nav.querySelector('.list-ul');
    const outer_list = nav.querySelector('.js-inpage-nav-inner-list');
    const prev = nav.querySelector('.js-inpage-prev');
    const next = nav.querySelector('.js-inpage-next');
    const list_items = [...inner_list.getElementsByClassName('list-item')];
    const list_item_links = list_items.map((item) => Array.from(item.querySelectorAll('a, span'))).flat();
    const items_max = list_items.length - 1;
    let inner_width = inner_list.getBoundingClientRect().width;
    let outer_width = outer_list.getBoundingClientRect().width;
    let overflows = inner_width > outer_width;
    let current_active = 0;
    let current_transform = 0;
    let btn_touched = false;
    let container_timeout;
    let current_centered;

    const containers = list_item_links.map(link => {
      const id_href = link.getAttribute('href');
      const id = id_href ? id_href.slice(1) : link.dataset.href.slice(1);

      const container = document.getElementById(id).parentNode;
      const rect = container.getBoundingClientRect();
      const top = rect.top + getScrollPos();
      const bottom = top + rect.height;


      return { link, container, id, rect, top, bottom };
    });

    function getNoHashUrl() {
      return document.title, window.location.pathname + window.location.search;
    }

    function ensureDisplay(link, linkIndex) {
      const rect = link.parentElement.getBoundingClientRect();


      if (rect.left < prev.getBoundingClientRect().right || rect.right > next.getBoundingClientRect().left) {
        calculateCenterOffset(linkIndex, transformWithinBounds);
        nav.classList.remove('inpage-nav--active-first', 'inpage-nav--active-last');
        onUp();
      }
    }

    /**
     * 
     * @param {Object} e data about the event triggering the update. Expected properties:
     * e.index - the index of the current section on the page
     * e.hash - the hash ('#' + id) of the current section on the page
     */
    function updateCurrentSection(e) {


      const index = e.index;
   
      Array.from(inner_list.querySelectorAll(`.${LINK_CURRENT_CLASS}`)).forEach((curLink) => curLink.classList.remove(LINK_CURRENT_CLASS));

      const linkIndex = Math.max(0, index)
      if (list_item_links[linkIndex]) {
        const link  = list_item_links[linkIndex];
        if (link) {
          link.parentElement.classList.add(LINK_CURRENT_CLASS);
          current_active = linkIndex;

          ensureDisplay(link, linkIndex);
        }
      }

      if (e.hash || e.index == -1) {
        const newHash = e.hash || getNoHashUrl();
        if (newHash != window.location.hash) {
          pushState({ newHash, index }, document.title, newHash);
        }
      }
      
    }


    // Setup scrollspy.

    const scrollSpy = new ScrollSpy({
      linksContainerSelector: '.js-inpage-nav-inner-list',
      sectionSelector: '.js-inpage-nav-target',
      linkCurrentClass: 'active',
      documentScroller: documentScroller,
      updateSectionCallback: updateCurrentSection,
      initHash: window.location ? window.location.hash : null
    });

    list_item_links.forEach((el, i) => {
      el.addEventListener('click', e => {
        updateCurrentSection({
          index: i,
          hash: null, //do not need to pass the hash because it is updated by the click handler
          src: 'click'
        }, scrollSpy)
      });

      el.addEventListener('focus', () => ensureDisplay(el, i));
    });

    let win_height = window.innerHeight;

    // update containers rect and win_height after resize is finished
    window.addEventListener('resize', () => {
      clearTimeout(container_timeout);

      container_timeout = setTimeout(() => {
        win_height = window.innerHeight;
        containers.forEach(cont => {
          cont.rect = cont.container.getBoundingClientRect();
          cont.top = cont.rect.top + getScrollPos();
          cont.bottom = cont.top + cont.rect.height;
        });
      }, 300);
    });


    /**
     * Makes sure that element is centered, but only within bounds.
     * @param  {[number]} x Adjustment value for an element to be exactly in the center.
     */
    function transformWithinBounds(x) {
      if (overflows) {
        let max = inner_width - outer_width;
        let move = x < 0 ? Math.max(x, -max) : 0;

        inner_list.style.transform = `translateX(${move}px)`;
        current_transform = move;
      } else {
        delete inner_list.style.transform;
        current_transform = 0;
      }
    }


    /**
     * Calulates offset of the center of the lement from the center of the container.
     * @param  {[number]} index Index of the element.
     * @return {[number]} Value of the offset needed to place center of the item in the center of the container.
     */
    function calculateCenterOffset(index, callback) {
      const item = list_items[index];
      const rect = item.getBoundingClientRect();
      const middle_outer = outer_width / 2;
      const middle_item = item.offsetLeft + (rect.width / 2);
      const offset = middle_outer - middle_item;

      if (callback) {
        callback(offset);
      }

      return offset;
    }

    /**
     * Finds out which element is next/prev from the one closed to the center
     * @param  {Function} callback callback function that receives desired offset value.
     * @param  {Number}   [direction=1] direction, -1 is backward, default 1 is forward.
     */
    function detectNextItemFromCenter(callback, direction = 1) {
      let value = 10000000;
      let index = 0;
      let next_index = 0;

      let offsets = list_items.map((n, i) => {
        let inner_val = calculateCenterOffset(i);

        if (Math.abs(inner_val) < value) {
          value = inner_val;
          index = i;
        }

        return inner_val;
      });

      index = current_centered || index;

      next_index = Math.max(Math.min(index + direction, offsets.length - 1), 0);

      if (callback) {
        nav.classList.remove('inpage-nav--active-first', 'inpage-nav--active-last');
        btn_touched = true;
        callback(offsets[next_index]);
        current_centered = next_index;
      }
    };

    /**
     * Sets the overflow class depending on overflow variable.
     */
    function setOverflowClass() {
      if (overflows) {
        nav.classList.add('inpage-nav--overflows');
      } else {
        nav.classList.remove('inpage-nav--overflows');
      }
    }


    setOverflowClass();


    document.body.addEventListener('back-to-top', () => {
      pushState({}, getNoHashUrl());
      calculateCenterOffset(0, transformWithinBounds);
    });

    window.addEventListener('resize', () => {
      inner_width = inner_list.getBoundingClientRect().width;
      outer_width = outer_list.getBoundingClientRect().width;

      // resets the last/first classes if they were altered by the prev/next buttons
      if (btn_touched && !(nav.classList.contains('inpage-nav-vertical'))) {
        nav.classList.remove('inpage-nav--active-first', 'inpage-nav--active-last');

        if (current_active === 0) {
          nav.classList.add('inpage-nav--active-first');
        } else if (current_active === items_max) {
         nav.classList.add('inpage-nav--active-last');
        }

        btn_touched = false;
        current_centered = undefined;
      }

      calculateCenterOffset(current_active, transformWithinBounds);

      if (overflows !== inner_width > outer_width) {
        overflows = !overflows;

        setOverflowClass();
      }
    });


    /**
     * Clean up after click.
     */
    function onUp() {
      let max = Math.floor(inner_width - outer_width);

      if (!(nav.classList.contains('inpage-nav-vertical'))) {
        if (current_transform === 0) {
          nav.classList.add('inpage-nav--active-first');
        } else if (Math.floor(Math.abs(current_transform)) === max) {
         nav.classList.add('inpage-nav--active-last');
        }
      }
    };

    next.addEventListener('click', e => {
      e.preventDefault();
      detectNextItemFromCenter(transformWithinBounds);
      onUp();
    });

    prev.addEventListener('click', e => {
      e.preventDefault();
      detectNextItemFromCenter(transformWithinBounds, -1);
      onUp();
    });
    //make sure changing hash doesn't scroll the window
    window.addEventListener('popstate', e => {
      if (e.state && e.state.isTriggeredFromCode) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopImmediatePropagation();
      } else {
        updateCurrentSection({
          index: scrollSpy.getIndexFromHash(window.location.hash),
          src: 'pop'
        });
      }
    });
    window.cmhrBetaBannerSettings.observeElementHeight(nav);
    document.documentElement.classList.add("has-inpage-nav");
  }
}
